import {useState} from "react";

import CommentIcon from "./CommentIcon";
import ResetIcon from "./ResetIcon";
import SetEmptyIcon from "./SetEmptyIcon";

/**
 * Column header with icons.
 * @param {object} props
 * @param {(value: any) => void} props.onReset
 * @param {React.ReactNode} props.title
 * @param {boolean} props.isActive
 * @param {boolean} props.showReset
 * @param {string|null} [props.comment]
 * @param {(comment: string|null) => void} props.addComment
 * @param {string} props.parameterType
 * @param {string} props.parameter
 * @param {string} props.label
 * @return {React.ReactNode}
 */
export function ColumnHeaderWithIcons({
    onReset,
    title,
    isActive,
    showReset,
    comment,
    addComment,
    parameterType,
    parameter,
    label,
}) {
    const [commentOpen, setCommentOpen] = useState(false);

    if (!isActive) {
        return <span className="p-column-title">{title}</span>;
    }

    return (
        <>
            <span className="p-column-title">{title}</span>
            <CommentIcon
                parameterType={parameterType}
                open={commentOpen}
                onOpen={() => setCommentOpen(true)}
                onClose={() => setCommentOpen(false)}
                onConfirm={(text) => addComment(text)}
                onClear={comment ? () => addComment(null) : null}
                comment={comment}
                label={label}
            />
            {showReset && <ResetIcon parameter={parameter} onValueChange={() => onReset(null)} />}
            <SetEmptyIcon onValueChange={() => onReset([])} />
        </>
    );
}
